export default __webpack_public_path__ + "c227e69160b525fcee26baddc47d6100.png";